import { render, staticRenderFns } from "./layout-footer.vue?vue&type=template&id=3875696a&scoped=true&"
import script from "./layout-footer.vue?vue&type=script&lang=js&"
export * from "./layout-footer.vue?vue&type=script&lang=js&"
import style0 from "./layout-footer.vue?vue&type=style&index=0&id=3875696a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3875696a",
  null
  
)

export default component.exports